export const AUTHOR_CODE = 'AUTHOR_CODE';
export const AUTHOR_INFO = 'AUTHOR_INFO';
export const USERINFO = 'USERINFO';
export const CANCALACTIVENAME = 'CANCALACTIVENAME';
export const TASKSINFODATA = 'TASKSINFODATA';
export const TASKSACCEPTANCESSTATISTICS = 'TASKSACCEPTANCESSTATISTICS';
export const TASKSACCEPTANCESLIST = 'TASKSACCEPTANCESLIST';
export const TASKSACCEPTANCESDATA = 'TASKSACCEPTANCESDATA';